export const I18N_PLATFORM_MAP = {
  en_US: 'en',
  zh_CN: 'zh-CN',
  zh_TW: 'zh-TW',
  fr_FR: 'fr',
  ko: 'ko',
  ja: 'ja',
  th: 'th',
  vi: 'vn',
  es: 'es',
  pt: 'pt',
  de: 'de',
  id: 'id',
  ar: 'ar',
  it: 'it',
  pl: 'pl',
  fa: 'fa',
  hi: 'hi',
  ru: 'ru',
}

export const I18N_PAYMENT_CENTER_MAP = {
  en_US: 'en_US',
  zh_CN: 'zh_CN',
  zh_TW: 'zh_TW',
  fr_FR: 'fr_FR',
  ko: 'ko_KR',
  ja: 'ja_JP',
  th: 'th_TH',
  vi: 'vi_VN',
  es: 'es_ES',
  pt: 'pt_PT',
  de: 'de_DE',
  id: 'id_ID',
  ar: 'ar_SA',
  ru: 'ru_RU',
  mn: 'mn_MN',
  km: 'km_KH',
  nl: 'nl_NL',
  it: 'it_IT',
  ms: 'ms_MY',
  pl: 'pl_PL',
  tl: 'tl_PH',
  fa: 'fa-IR',
  hi: 'hi-IN',
}

export const RTL_LANGUAGE_LIST = ['ar', 'fa']

export const languageMap = {
  ENGLISH: 'common.lang.english',
  ENGLISH_GCN: 'common.lang.englishGCN',
  RUSSIA: 'common.lang.russian',
  ENGLISH_IRAQ: 'common.lang.englishIQ',
  CHINESE: 'common.lang.chinese',
  TRADITIONAL_CHINESE: 'common.lang.traditionalChinese',
  FRENCH: 'common.lang.french',
  THAI: 'common.lang.thai',
  GERMAN: 'common.lang.german',
  SPANISH: 'common.lang.spanish',
  MALAY: 'common.lang.malay',
  MY_CHINESE: 'common.lang.chineseMY',
  MY_ENGLISH: 'common.lang.englishMY',
  VIETNAMESE: 'common.lang.viet',
  INDONESIAN: 'common.lang.indo',
  PORTUGUESE: 'common.lang.portuguese',
  KOREAN: 'common.lang.korean',
  ARABIC: 'common.lang.arabic',
  ITALIAN: 'common.lang.italian',
  FILIPINO: 'common.lang.filipino',
  TURKISH: 'common.lang.turkish',
  ENGLISH_EU: 'common.lang.eu',
  JAPANESE: 'common.lang.japanese',
  RUSSIAN: 'common.lang.russian',
  FARSI: 'common.lang.farsi', 
  PERSIAN: 'common.lang.persian', 
  POLSKI: 'common.lang.polski',
  POLISH: 'common.lang.polish',
  HINDI: 'common.lang.hindi',
  KHMER: 'common.lang.khmer',
  KH_ENGLISH: 'common.lang.englishCambodia'
};
